import { SVGProps } from 'react';

const ArrowUpFromDot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19 9-7-7-7 7m7-7v14m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default ArrowUpFromDot;
